import { Link } from '@tanstack/react-router';
import { ArrowUpRight, MessageSquareText } from 'lucide-react';
import { Button, PageHeader } from '@/shared/components';
import { PluginProblem } from './PluginProblem';
import { pluginStateLabel } from './pluginPresentation';
import { usePluginCatalogue } from './usePluginCatalogue';

export function PluginsPage() {
  const query = usePluginCatalogue();
  return (
    <>
      <PageHeader
        eyebrow="Verwaltung"
        title="Ihre"
        titleAccent="Plugins"
        description="Verbinden Sie ergänzende Anwendungen mit Ihrem Workspace. Sie bestimmen Umfang und Teamrechte."
      />
      <PluginProblem error={query.error} />
      {query.isPending && <p role="status">Plugins werden geladen…</p>}
      {query.isError && (
        <Button size="lg" onClick={() => void query.refetch()}>
          Erneut laden
        </Button>
      )}
      <div className="@container grid gap-6">
        {query.data?.map((plugin) => (
          <article
            key={plugin.id}
            className="bg-card border-line/60 shadow-card max-w-2xl rounded-lg border p-6"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="bg-sage/10 text-sage grid h-12 w-12 shrink-0 place-items-center rounded-md">
                <MessageSquareText aria-hidden />
              </div>
              <span className="text-ink-soft text-sm">
                {pluginStateLabel(plugin.installation?.state)}
              </span>
            </div>
            <h2 className="text-ink mt-6 font-serif text-3xl">{plugin.name}</h2>
            <p className="text-ink-soft mt-2 max-w-lg leading-relaxed">
              Ein eigener Arbeitsbereich für Ihre Gästekommunikation. Verbinden Sie Apartmentwissen
              und erlaubte Gespräche mit Ihrem Team.
            </p>
            <p className="text-ink-soft mt-4 text-sm">
              {!plugin.entitled
                ? 'Nutzungsrecht fehlt'
                : {
                    Free: 'Kostenfrei nutzbar',
                    Included: 'In Ihrem Paket enthalten',
                    AdminGranted: 'Für Ihren Workspace freigegeben',
                  }[plugin.entitlement]}
            </p>
            <Button asChild variant="primary" size="lg" className="mt-6">
              <Link
                to="/plugins/$pluginId"
                params={{ pluginId: plugin.id }}
                search={{ tab: 'overview' }}
              >
                Plugin ansehen <ArrowUpRight size={16} aria-hidden />
              </Link>
            </Button>
          </article>
        ))}
      </div>
    </>
  );
}
